<div class="panel panel-default">
  <div class="panel-heading">Harvest Report</div>
  <div class="panel-body">
    <div class="form-horizontal" [formGroup]="rootForm">
    
      <div class="form-group" [class.has-error]="startDateFormControl.invalid">
        <label class="control-label col-sm-4 col-md-2">Start Date</label>
        <app-ce-date-picker
          [formControl]="startDateFormControl"
          placement="right">
        </app-ce-date-picker>
      </div>
        
      <div class="form-group" [class.has-error]="endDateFormControl.invalid">
        <label class="control-label col-sm-4 col-md-2">End Date</label>
        <app-ce-date-picker
          [formControl]="endDateFormControl"
          placement="right">
        </app-ce-date-picker>
      </div>
        
      <div class="form-group" [class.has-error]="cropFormControl.invalid">
        <label class="control-label col-sm-4 col-md-2">Crop</label>
        <div class="col-sm-8">
          <select class="form-control" [formControl]="cropFormControl">
            <option [ngValue]="null"></option>
            <option *ngFor="let crop of crops" [ngValue]="crop.id">
              {{ crop.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
        
    <div class="col-sm-offset-4 col-md-offset-2 col-sm-8">
      <button type="button" class="btn btn-primary pull-right" [disabled]="rootForm.invalid" (click)="generateReport()">Get Report</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/harvest-report-form/harvest-report-form.component.html